import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import styles from "./MyAccount.module.css";
import logo from "../../images/logo.svg";
import favIcon from "../../images/fav.svg";
import collectionIcon from "../../images/logo-white.svg";
import offerIcon from "../../images/offer.svg";
import recievedIcon from "../../images/recieve.svg";
import madeIcon from "../../images/made.svg";
import wall2 from "../../images/wall1.jpg";
import logoutIcon from "../../images/logout.svg";
import {
  toggleSideBar,
  updateAccountTab,
  resetUser,
} from "../../store/actions";
import MadeSection from "./MadeSection";
import RecievedSection from "./RecievedSection";
import CollectionSection from "./CollectionSection";
import BidsSection from "./BidsSection";
import FavoritesSection from "./FavoritesSection";
import SingleLink from "./SingleLink";
import ArrowBar from "./ArrowBar";
import TransactionSection from "./TransactionSection";
import { checkCookie, deleteCookie } from "../Common";

const MyAccount = () => {
  let history = useHistory();
  const dispatch = useDispatch();
  const loggedUser = useSelector((state) => state.loggedUser);
  const activeAccountTab = useSelector((state) => state.activeAccountTab);
  const profileSideBarToggle = useSelector(
    (state) => state.profileSideBarToggle
  );

  if (!checkCookie("active_user")) {
    history.push("/");
  }

  return (
    <>
      <section
        className={styles.header}
        style={{
          background: `radial-gradient( rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100% ), url('${
            loggedUser.profile_image ? loggedUser.profile_image : wall2
          }')`,
        }}
      >
        <img
          src={logo}
          className={`${styles.logo} cursor-pointer`}
          onClick={() => {
            dispatch(updateAccountTab("Favorites"));
            history.push("/");
          }}
          alt="Logo"
        />
        <div>
          <h2 className={styles.name}>
            {loggedUser.name ? loggedUser.name : loggedUser.username}
          </h2>
          <p className={styles.userId}>{loggedUser.uid}</p>
        </div>
      </section>
      <section className={styles.main}>
        <div
          className={`${styles.sidebar} ${
            profileSideBarToggle ? styles.sidebarActive : null
          }`}
        >
          <ArrowBar onClick={() => dispatch(toggleSideBar())} />
          <SingleLink
            icon={favIcon}
            title="Favorites"
            onclick={() => dispatch(updateAccountTab("Favorites"))}
          />
          <SingleLink
            icon={collectionIcon}
            title="Collection"
            onclick={() => dispatch(updateAccountTab("Collection"))}
          />
          <SingleLink
            icon={offerIcon}
            title="Transaction"
            onclick={() => dispatch(updateAccountTab("Transaction"))}
          />
          <SingleLink
            icon={offerIcon}
            title="Bids"
            onclick={() => dispatch(updateAccountTab("Bids"))}
          />
          <SingleLink
            icon={recievedIcon}
            title="Recieved"
            onclick={() => dispatch(updateAccountTab("Recieved"))}
          />
          <SingleLink
            icon={madeIcon}
            title="Made"
            onclick={() => dispatch(updateAccountTab("Made"))}
          />
          <SingleLink
            icon={logoutIcon}
            title="Logout"
            onclick={() => {
              deleteCookie("active_user");
              dispatch(resetUser());
              dispatch(updateAccountTab("Favorites"));
            }}
          />
        </div>
        <div
          className={`${styles.mainContent} ${
            profileSideBarToggle ? styles.mainContentActive : null
          }`}
        >
          {activeAccountTab === "Favorites" ? (
            <FavoritesSection />
          ) : activeAccountTab === "Collection" ? (
            <CollectionSection />
          ) : activeAccountTab === "Bids" ? (
            <BidsSection />
          ) : activeAccountTab === "Recieved" ? (
            <RecievedSection />
          ) : activeAccountTab === "Made" ? (
            <MadeSection />
          ) : activeAccountTab === "Transaction" ? (
            <TransactionSection />
          ) : null}
        </div>
      </section>
    </>
  );
};

export default MyAccount;
